export default {"src":"/_next/static/media/artichokes.b97831ab.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};